<div class="upload-container" fxLayout="column">
  <div fxFlex="100%" fxFlexAlign="end">
    <button *ngIf="displayUploadButton" mat-button [ngClass]="uploadButtonClass" (click)="documentUpload.click()">
      {{ uploadText }}
    </button>
    <input
      type="file"
      id="documentUpload"
      #documentUpload
      ng2FileSelect
      [uploader]="uploader"
      (change)="documentUpload.value = ''"
    />
    <div
      class="scan-message"
      layout="row"
      layout-sm="column"
      layout-align="space-around"
      *ngIf="displayDocumentScanningMessage"
    >
      Scan in progress.
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
  </div>
  <label class="error-message" *ngIf="this.errorMessage" fxFlex="100%">{{ this.errorMessage }}</label>
</div>
